module.exports = __webpack_public_path__ + "img/bayern-munich.0dfac337.png";